import * as React from 'react';
import styled from 'styled-components';
import i18n from './../i18n';

const LanguageChangeWrapper = styled.div`
    position: absolute;
    right: 2px;
    top: 2px;
    background-color: white;
    padding: 5px;
    border-radius: 2px;
    width: 60px;
    display: flex;
    justify-content: space-between;
    box-shadow: 0 2px 2px 0 rgba(0,0,0,0.14), 0 1px 5px 0 rgba(0,0,0,0.12), 0 3px 1px -2px rgba(0,0,0,0.2);
`;

const LanguageOption = styled.span`
    cursor: pointer;
    color: ${props => props.selected ? '#000' : '#666'};
    font-weight: ${props => props.selected ? 600 : 400};
    :hover{
        font-weight: 800;
    }

`;

const LanguageChanger = ({visible}) => {
    if(visible) {
        return (
            <LanguageChangeWrapper>
                <LanguageOption
                    selected={localStorage.getItem('language') === 'pl'}
                    onClick={
                        () => {
                            localStorage.setItem('language', 'pl');
                            i18n.changeLanguage('pl');
                        }
                    }>
                    PL
                </LanguageOption>
                <LanguageOption
                    selected={localStorage.getItem('language') === 'en'}
                    onClick={
                        () => {
                            localStorage.setItem('language', 'en');
                            i18n.changeLanguage('en');
                        }
                    }>
                    ENG
                </LanguageOption>
            </LanguageChangeWrapper> 
        );
    }
    return false;
}

export default LanguageChanger;



// WEBPACK FOOTER //
// ./src/components/LanguageChanger.jsx